import { VERNACULAR_DEFAULT_MESSAGES } from "constants/vernacularConstants";


interface ValidationReturnType{ error: string, hasError: boolean, isLatinDetected?: boolean };

/**
 * validation function for pincode field
 * @param value of type string or null
 */
 export const validatePinCode = (pinCode:string|null, errors?: {required: string, invalid: string}): ValidationReturnType => {
  let error = "";
  let hasError = false;
  if (!pinCode) {
    error = (errors && errors.required) || VERNACULAR_DEFAULT_MESSAGES.THIS_FIELD_IS_REQUIRED;
    hasError = true;
  } else if (pinCode.length !== 6) {
    error = (errors && errors.invalid) || VERNACULAR_DEFAULT_MESSAGES.INVALID_PINCODE;
    hasError = true;
  } else if (parseInt(pinCode.charAt(0)) === 0) {
    error = (errors && errors.invalid) || VERNACULAR_DEFAULT_MESSAGES.INVALID_PINCODE_ZERO;
    hasError = true;
  } else {
    error = "";
  }

  return {
    error,
    hasError,
  };
};
